// extracted by mini-css-extract-plugin
export default {"grid_three":"ApplicantDemographics_grid_three__fliUb","grid_two":"ApplicantDemographics_grid_two__QGoaA"};